import { Card } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PageContainer } from '../../../../components/molecules/page-container';
import { PageHeader } from '../../../../components/molecules/page-header';
import { CreateBillingGroupForm } from '../organisms/create-billing-group-form/create-billing-group-form';

import { withPermissions } from '@/permissions/can';

const EditBillingGroup = () => {
  const { t } = useTranslation(['billingGroups']);

  return (
    <PageContainer helmetPageTitle={t('billingGroups:tab')}>
      <PageHeader title={t('billingGroups:edit')} />
      <Card
        variant="outlined"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        }}>
        <CreateBillingGroupForm />
      </Card>
    </PageContainer>
  );
};

export default withPermissions(
  permissions => permissions.cannot('manageParkingDiscounts', 'BillingGroups'),
  EditBillingGroup,
);
